import { Box } from '@atom-web/micros'

const ContentWrapper = ({
	disablePadding = false,
	padding = '16px',
	children,
	css = {},
}) => {
	return (
		<Box
			css={{
				marginRight: 'auto',
				marginLeft: 'auto',
				width: '100%',
				position: 'relative',
				paddingLeft: disablePadding ? 0 : padding,
				paddingRight: disablePadding ? 0 : padding,
				...css,
				'@sm': {
					width: '768px',
					...css['@sm'],
				},
				'@lg': {
					width: '1024px',
					paddingLeft: '64px',
					paddingRight: '64px',
					...css['@lg'],
				},
				'@xl': {
					width: '1280px',
					paddingLeft: '64px',
					paddingRight: '64px',
					...css['@xl'],
				},
			}}
		>
			{children}
		</Box>
	)
}

export default ContentWrapper
